// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/icing-distribution.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/icing-distribution/icing-distribution.js';

mount([g0]);
